import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Cutomer_Title_Interface } from 'src/app/Interface/Cutomer_Title_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';

@Component({
  selector: 'app-CutomerTitle',
  templateUrl: './CutomerTitle.component.html',
  styleUrls: ['./CutomerTitle.component.scss']
})
export class CutomerTitleComponent implements OnInit {

  @Input() Customer_Inner:Customer_List_Interface

  @Output() OnBack_Title_Action = new EventEmitter<number>();
  Proccessing:boolean=false
  page:number=0

  ngOnChanges(changes: SimpleChanges): void {
    this.Read_Title()
  }

  constructor(
    private Customer_Service: CustomerService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
  }


  OnSet_Back_TitleView(){
    this.OnBack_Title_Action.emit(-1);
  }


  DataList_Title: Array<Cutomer_Title_Interface> = []


  Read_Title(){
    this.Proccessing=true
    this.Customer_Service.GetCustomerTitle(this.Customer_Inner.id).subscribe(
      data=>{
        this.Proccessing=false
        this.DataList_Title=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }




}
